import React, { Component } from 'react';
import { Row, Col, Icon, List, Modal, Button } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LoadingBar from 'react-redux-loading-bar';
import Login from '../authentification/LogIn';
import CardEvent from '../event/CardEvent';
import * as actions from './redux/actions';
import PresenceHandler from './PresenceHandler';

class Presence extends Component {
    state = { loginVisible: false, eventVisible: false, selected: null, isAddUser: false }

    componentDidMount() {
        this.props.actions.getEvents();
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isAuth && this.props.isAuth) {
            this.setState({ loginVisible: false })
        }
    }

    showEvent(event) {
        this.setState({ eventVisible: true, selected: event })
    }

    renderEvents() {
        const events = this.props.isAdmin ? this.props.presence.list :
            this.props.presence.list.filter(event => event.moderators.find(mod => mod.user.email === this.props.userEmail));
        return events ? (
            <Col span={20} offset={2}>
                <List 
                    size="large"
                    dataSource={events}
                    renderItem={item => (<CardEvent key={item.id} item={item} showPresence={(event) => this.showEvent(event)} />)}
                />
            </Col>
            ) : undefined;
    }
    
    render() {
        return (
            <div>
                <Row>
                    <Col span={16} offset={4} className="title-home">
                        <h3><Icon type="minus" />    Présences   <Icon type="minus" /></h3>
                    </Col>
                </Row>
                    {
                        this.props.isAuth &&
                            <Row style={{ textAlign: "center" }}>
                                <Button 
                                    className="btn-compte ui-btn" 
                                    icon="reload" 
                                    onClick={() => this.props.actions.getEvents()} 
                                    style={{ position:'relative', right: '0', marginBottom: "16px" }}
                                >Rafraîchir</Button>
                            </Row>
                    }
                <Row>
                    {
                        this.props.isAuth ? 
                            (this.props.presence.loading ?
                                <LoadingBar className="loading-bar" style={{ marginTop: "-18px" }} /> :
                                this.renderEvents()) :
                                <Col span={16} offset={4} style={{ textAlign: 'center', marginTop: '150px' }}>
                                    <Button 
                                        className="btn-compte ui-btn" 
                                        icon="login" 
                                        onClick={() => this.setState({ loginVisible: true })} 
                                        style={{ position:'relative', right: '0' }}
                                    >Connexion</Button>
                                </Col>
                    }
                </Row>
                <Modal
                    className="modal-event"
                    visible={this.state.loginVisible}
                    onCancel={() => this.setState({ loginVisible: false })}
                >
                    <div className="content-form"><Login fromPresence /></div>
                </Modal>
                <Modal
                    className="modal-event"
                    visible={this.state.eventVisible}
                    onCancel={() => this.state.isAddUser ? 
                        this.setState({isAddUser:false}) : 
                        this.setState({ eventVisible: false, selected: null })}
                >
                    <div className="content-form">
                        { this.state.selected && 
                            <PresenceHandler 
                                event={this.state.selected}
                                addUser={this.state.isAddUser}
                                toggleAddUser={() => this.setState({isAddUser: !this.state.isAddUser})}
                            />
                        }
                    </div>
                </Modal>
            </div>
        );
    }
}

  /* istanbul ignore next */
  function mapStateToProps(state) {
    return {
      presence: state.presence,
      isAuth: state.authentification.isAuth,
      isAdmin: state.authentification.isAdmin,
      userEmail: state.authentification.user.email
    };
  }
  
  /* istanbul ignore next */
  function mapDispatchToProps(dispatch) {
    return {
      actions: bindActionCreators({ ...actions }, dispatch)
    };
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Presence);


// WEBPACK FOOTER //
// ./src/features/presence/Presence.js